<template>
  <div class="globalSettins_page">
    <div class="status_list">
      <MonitoringStatusItem
        v-for="(list, key) in status_list"
        :key="key"
        class="setting-item"
        :list="list"
        :title="key"
        @edit="new_API"
      />
    </div>
  </div>
</template>

<script>
import GlobalSettingsEdit from '../Parameters/Edit/Index.vue'
import MonitoringStatusItem from './Item/Index.vue'
export default {
  name: 'DatabaseStatus',
  components: {
    MonitoringStatusItem
  },
  data () {
    return {
      status_list: {}
    }
  },
  mounted () {
    this.$http.v1.getMonitoringStatus((response) => {
      this.status_list = response.data
    })
  },
  methods: {
    new_API (val) {
      var t = this.$createElement(GlobalSettingsEdit, {props: {ips: val}, on: {close: () => { this.$modal.hide('dynamic-modal') }, update: (val) => { this.update(val) }}})
      let temp = {render () { return t }}
      this.$modal.show(temp, {}, {height: 'auto', name: 'dynamic-modal'})
    }
  }
}
</script>

<style lang="scss" scoped>
  .globalSettins_page{
    height: 100%;
    overflow-y: auto;
    padding: 0 5px 5px 0;
  }
  .status_list{
    column-count: 2;
    column-gap: 10px;

    .setting-item{
      display: inline-block;
      width: 100%;
      margin-bottom: 10px;
      break-inside: avoid;
      vertical-align: top;
    }
  }

  @media (max-width: 991px) {
    .status_list{
      column-count: 1;
    }
  }
</style>
